export default __webpack_public_path__ + "static/8-0df39c7eac9e2f9763f4fb8673e2a904.webp";